export default {
	title: 'Son développement',
	liensutiles: 'Liens utiles :',
	mois1: {
		text: 'A partir du mois prochain, nous vous donnerons des repères pour suivre l’évolution de votre enfant.',
		liens: [
			'accompagnepremier'
		]
	},
	mois2: {
		text: 'Votre bébé commence à faire des vocalises, il sourit, tourne la tête vers celui qui l’appelle, fixe bien votre visage quand vous lui donnez à boire et vous regarde dans les yeux. Sur le ventre, quand il est éveillé, il commence à soulever la tête puis les épaules.',
		liens: [
			'accompagnepremier'
		]
	},
	mois3: {
		text: 'Votre bébé fait des vocalises de plus en plus riches, gazouille, se tourne du côté sur le dos, puis du ventre sur le dos.',
		liens: [
			'accompagnepremier'
		]
	},
	mois4: {
		text: 'Votre bébé réagit quand on lui tend les bras et tourne la tête quand on l’appelle.',
		liens: [
			'accompagnepremier'
		]
	},
	mois6: {
		text: 'Votre bébé rit aux éclats et attrape les objets.',
		liens: [
			'accompagnepremier'
		]
	},
	mois8: {
		text: 'Votre bébé prononce plusieurs syllabes différentes et commence peu à peu à se tenir assis.',
		liens: [
			'accompagnepremier'
		]
	},
	mois11: {
		text: 'Votre bébé tient bien assis, aime jeter ses jouets, commence à faire les marionnettes et « au revoir » avec la main ou le bras.',
		liens: [
			'accompagnepremier'
		]
	},
	mois12: {
		text: 'Votre enfant dit ses premiers mots ! Il aime qu’on lui raconte des histoires.',
		liens: [
			'accompagnepremier'
		]
	},
	mois15: {
		text: 'Votre enfant commence à marcher (entre 9 et 20 mois selon les enfants).',
		liens: [
			'accompagnepremier'
		]
	},
	mois18: {
		text: 'Votre enfant utilise son index pour désigner quelque chose ou quelqu’un et répond à vos sourires.',
		liens: [
			'accompagnepremier'
		]
	},
	mois23: {
		text: 'Votre enfant connaît plusieurs mots et commence à faire des phrases de 2 mots. Il court et tape dans des ballons.',
		liens: [
			'accompagnepremier'
		]
	},
	mois24: {
		text: 'Votre enfant utilise son index pour désigner quelque chose ou quelqu’un, il joue à faire semblant, vous imite dans la vie quotidienne, répond à vos sourires.',
		liens: [
			'accompagnepremier'
		]
	},
	mois36: {
		text: '<p>Votre enfant apprend à dire son prénom et son nom puis à dire « je ». Il sait rester attentif quand vous lui racontez une histoire, il commence à monter les escaliers en alternant les pieds.</p><p>La corpulence des enfants augmente jusqu’à 1 an puis diminue jusqu’à 6 ans et remonte ensuite. Pour mesurer la corpulence, le médecin calcule, à partir de la taille et du poids de votre enfant, l’Indice de Masse Corporelle (IMC) et reporte ce chiffre sur les courbes de corpulences figurant dans le carnet de santé. La remontée de cette courbe vers 6 ans s’appelle le rebond d’adiposité.</p><p>Si ce rebond intervient trop tôt, avant l’âge de 6 ans, l’enfant risque de développer un surpoids dans l’enfance, voire une obésité à l’âge adulte.</p><p>Il est donc utile de remplir régulièrement les courbes de croissance (poids, taille, IMC) dans le carnet de santé de votre enfant et d’en discuter avec votre médecin.</p>',
		liens: [
			'accompagnepremier'
		]
	},
	mois48: {
		text: '<p>Votre enfant aime jouer avec d’autres enfants, comprend et participe quand on lui raconte des histoires, lance des balles.</p><p>La corpulence des enfants augmente jusqu’à 1 an puis diminue jusqu’à 6 ans et remonte ensuite. Pour mesurer la corpulence, le médecin calcule, à partir de la taille et du poids de votre enfant, l’Indice de Masse Corporelle (IMC) et reporte ce chiffre sur les courbes de corpulences figurant dans le carnet de santé. La remontée de cette courbe vers 6 ans s’appelle le rebond d’adiposité.</p><p>Si ce rebond intervient trop tôt, avant l’âge de 6 ans, l’enfant risque de développer un surpoids dans l’enfance, voire une obésité à l’âge adulte.</p><p>Il est donc utile de remplir régulièrement les courbes de croissance (poids, taille, IMC) dans le carnet de santé de votre enfant et d’en discuter avec votre médecin.</p>'
	},
	mois60: {
		text: 'Votre enfant est capable de décrire une image. Son dessin s’organise peu à peu : les bonhommes ont 4 membres, un tronc et une tête. Entre 4 et 10 ans, votre enfant va grandir en moyenne de 5 cm par an.'
	},
	mois84: {
		text: '<p>Les notions de haut-bas, devant-derrière et dessus-dessous sont acquises vers 6 ans. Votre enfant entre à l’école élémentaire où il apprend à lire.</p><p>C’est une étape cruciale au cours de laquelle il va être capable de développer une relation aux autres, différente de ce qu’il a connu jusqu\'à maintenant.</p>'
	},
	mois108: {
		text: 'Dans 95% des cas, la puberté débute entre 8 et 13 ans chez les filles et entre 9 et 15 ans chez les garçons.'
	},
	mois156: {
		text: '<p>Votre enfant va débuter sa puberté et avec elle de nombreux changements vont apparaître. Ces modifications physiques, intellectuelles, psychiques sont une transition indispensable avant le passage à l’âge adulte.</p><p>L’adolescence et la puberté sont des moments déroutants pour votre enfant : il va demander plus d’autonomie et, en même temps, rester fragile. Il aura donc encore besoin de vous.</p><p>L’adolescence est aussi le moment de la découverte, des expériences nouvelles. La plupart sont nécessaires à sa construction. Cependant, les tentations sont grandes et il faut rester vigilant. Si le comportement de votre enfant change (chute des notes scolaires, enfermement sur lui-même, comportement agressif, comportement alimentaire perturbé), n’hésitez pas à en parler avec lui, avec l’aide d’un médecin si cela est nécessaire.</p><p>Il est important d’essayer de maintenir un dialogue entre vous et votre enfant afin qu’il puisse se tourner vers vous en cas de difficultés.'
	}
};
